import React from 'react';
import { StyledModal } from './styledComponents';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

const PrivacyPolicyModal = ({
  modalVisible,
  setModalVisible,
  baaModalVisible,
  setBaaModalVisible
}) => {
  const pdfUrl = modalVisible
    ? 'https://cascadedev.blob.core.windows.net/default-public/PrivacyPolicy.pdf#navpanes=0'
    : 'https://cascadedev.blob.core.windows.net/default-public/CascadeMDBAAforwebsite.pdf#navpanes=0';

  return (
    <>
      <StyledModal
        visible={modalVisible || baaModalVisible}
        key={modalVisible || baaModalVisible}
        footer={[]}
        title={modalVisible ? 'Privacy Policy' : 'Business Associate Agreement'}
        closeIcon={
          <Button
            icon={<CloseOutlined />}
            onClick={() => {
              modalVisible && setModalVisible(false);
              baaModalVisible && setBaaModalVisible(false);
            }}
          />
        }
        privacy={true}
      >
        <iframe
          src={pdfUrl}
          width="100%"
          height="100%"
          style={{ border: 'none' }}
          title={modalVisible ? 'Privacy Policy' : 'Business Associate Agreement'}
        />
      </StyledModal>
    </>
  );
};

export default PrivacyPolicyModal;
